export const primary = "#3ed6f0";
export const secondary = "#252e3e";
export const gray = "#e2e2e2";
export const white = "#f7f7f7";
export const burntOrange500 = "hsl(14, 55%, 45%, 1)";
export const rgbValuesPrimary = "62, 214, 240";
export const rgbValuesSecondary = "37, 46, 62";
export const success = "hsla(134, 41%, 88%, 0.6)";
export const successDeep = "hsl(132, 60%, 25%)";
export const warning = "hsla(46, 100%, 90%, 0.6)";
export const warningDeep = "hsl(39, 76%, 44%)";
export const error = "hsla(355, 70%, 91%, 0.6)";
export const errorDeep = "hsl(355, 63%, 36%)";
export const primaryFontFamily = "\"DIN Condensed Bold\"";
export const secondaryFontFamily = "\"Encode Sans\"";
export const smallViewportWidth = "576px";
export const mediumViewportWidth = "768px";
export const largeViewportWidth = "992px";
export const extraLargeViewportWidth = "1200px";
export const borderRadius = "3px";
export const navBarHeight = "65px";
export const navBarTopGutterHeight = "20px";
export const typicalMaxWidth = "65ch";
